import React from 'react';
import { DohaDocument } from './pages/DohaDocument';
export function App() {
  return <DohaDocument data-id="element-0" />;
}